export default (function (params) {
    var check = params[0], value = params[1], _a = params[2], alternative = _a === void 0 ? null : _a;
    return check ? value : alternative;
});
//# sourceMappingURL=rave-if.js.map